import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgReceived = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 10" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#979797">
      <path d="m.834 5.393 4.05 3.982L13.96.625" />
      <path d="m5.209 5.393 4.05 3.982 9.075-8.75" />
    </g>
  </svg>
);
const Memo = memo(SvgReceived);
export default Memo;
